// src/domains/index.ts —— H5 域组合：shell 外壳 + 业务域（auth / cards / wallet / me），全部原生实现（TD-824 影子实例已退场）
import { auth } from './auth';
import { cards } from './cards';
import { me } from './me';
import { createShell } from './shell';
import type { H5Domain } from './types';
import { wallet } from './wallet';

const features: readonly H5Domain[] = [auth, cards, wallet, me];
export const shell = createShell(() => features);
export const DOMAINS: readonly H5Domain[] = [shell, ...features];
